import React from "react";
import ShMunAnimatedGif from "global/images/ShMunAnimatedGif-inside.gif";
import STRIPAnimatedGif from "global/imagesTemp/STRIPAnimatedGif-inside.gif";
import styles from "./Overlay.module.scss";
import { useSelector } from "react-redux";

const LoadingOverlay = () => {

	const { Spinner } = useSelector((state) => state.portalStyle);

	return (
		<div className={styles.overlay} id='overlay'>
			<img
				src={Spinner}
			/>
		</div>
	);
};

export default LoadingOverlay;
